import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { commonToast } from "../../Utils";
import { LoadingButton } from "../../Utils/CustomComponent";
import { Background } from "../Login/LoginComp";
import CodeInput from "../Login/mfa/CodeInput";
import PasswordStep from "./PasswordStep";
import useForgotPasswordV2 from "./useForgotPasswordV2";

// Forgot Password on step-up (docs/specs/password-reset-stepup.md). Shown instead of the temp-key screens when
// REACT_APP_PASSWORD_RESET_V2 is on (ForgotPasswordGate). `inModal` = the login page's modal, no page background.
const CODE_TEXT = {
  email: (email) => `We sent a 6-digit code to ${email}. It may take a minute to arrive.`,
  totp: () => "Your account uses an authenticator app. Enter the 6-digit code it shows.",
};
const NO_PHONE = "Lost the phone with your authenticator app? Please contact support to reset your password.";

const ForgotPasswordV2 = ({ inModal = false, closeModal }) => {
  const navigate = useNavigate();
  const [emailInput, setEmailInput] = useState("");
  const [code, setCode] = useState("");
  const finish = () => {
    toast.success("Password changed. Please sign in with your new password.", commonToast);
    if (closeModal) closeModal();
    else navigate("/login");
  };
  const flow = useForgotPasswordV2({ onDone: finish });

  const onEmail = (event) => {
    event.preventDefault();
    if (emailInput.trim() && !flow.busy) flow.submitEmail(emailInput);
  };
  const onCode = (event) => {
    event.preventDefault();
    if (!flow.busy) flow.submitCode(code);
  };

  const body = (
    <div className={inModal ? "" : "w-75"}>
      {!inModal && <h3 className="pb-5 mb-3">Reset Password</h3>}
      {flow.step === "email" && (
        <form onSubmit={onEmail} noValidate>
          <Form.Group className="mb-3" controlId="forgot-email">
            <Form.Label>Email address</Form.Label>
            <Form.Control type="email" autoComplete="email" value={emailInput}
              onChange={(e) => setEmailInput(e.target.value)} autoFocus />
          </Form.Group>
          {flow.error && <p className="text-danger" role="alert">{flow.error}</p>}
          <LoadingButton type="submit" title="Continue" loading={flow.busy}
            disabled={!emailInput.trim() || flow.busy} className="w-100" />
        </form>
      )}
      {flow.step === "code" && (
        <form onSubmit={onCode} noValidate>
          <p>{CODE_TEXT[flow.method](flow.email)}</p>
          <CodeInput method={flow.method} value={code} onChange={setCode} disabled={flow.busy}
            onResend={flow.canResend ? flow.resend : undefined} />
          {flow.method === "totp" && <p className="small text-muted">{NO_PHONE}</p>}
          {flow.error && <p className="text-danger" role="alert">{flow.error}</p>}
          <LoadingButton type="submit" title="Verify" loading={flow.busy} disabled={flow.busy} className="w-100" />
        </form>
      )}
      {flow.step === "password" && (
        <PasswordStep email={flow.email} busy={flow.busy} error={flow.error}
          onSubmit={flow.submitPassword} submitLabel="Save password" />
      )}
      {flow.step === "done" && <p role="status">Password changed.</p>}
    </div>
  );

  return inModal ? body : <Background>{body}</Background>;
};

export default ForgotPasswordV2;
